import type { ReactNode } from 'react';
import { T } from '@transifex/react';
import { XpIcon } from '~/components/ui/gamification/icons/xp-icon';

type XpBadgeProps = {
  xp: number;
};

export function XpBadge({ xp }: XpBadgeProps) {
  return (
    <span className="inline-flex items-center gap-xs align-middle">
      <XpIcon size="xs" aria-hidden />
      <span className="text-h3 text-green-700">
        <T _str="{xp} XP" xp={xp} />
      </span>
    </span>
  );
}

const XP_PATTERN = /\{?\{XP\}?\}/i;

/**
 * Replace `{XP}` or `{{XP}}` in `text` with an inline `<XpBadge>`.
 * If no placeholder is found, returns the text as-is (no badge appended).
 */
export function interpolateXp(text: string, xp: number): ReactNode {
  const match = XP_PATTERN.exec(text);
  if (!match) return text;

  const before = text.slice(0, match.index).trimEnd();
  const after = text.slice(match.index + match[0].length).trimStart();

  return (
    <span className="flex flex-wrap items-center gap-sm">
      {before ? <span>{before}</span> : null}
      <XpBadge xp={xp} />
      {after ? <span>{after}</span> : null}
    </span>
  );
}
